// extracted by mini-css-extract-plugin
module.exports = {"reportProfile":"ReportProfile_reportProfile__-gsfd"};